import { equipmentCategories } from '../../data/equipment';
import Button from '../common/Button';
import SectionHeading from '../common/SectionHeading';

function EquipmentPreview() {
  return (
    <section className="equipment-preview" aria-labelledby="equipment-preview-title">
      <div className="container">
        <SectionHeading
          title="Equipment We Repair"
          text="Focused repair support for gearboxes, hydraulic cylinders, and related industrial equipment."
        />
        <div className="equipment-preview__grid">
          {equipmentCategories.map((item) => (
            <article key={item.id} className="equipment-card">
              <div
                className="equipment-card__image"
                style={{ '--equipment-image': `url(${process.env.PUBLIC_URL}${item.image})` }}
                aria-label={`${item.title} repair image`}
              />
              <h3>{item.title}</h3>
              <p>{item.summary}</p>
            </article>
          ))}
        </div>
        <div className="equipment-preview__action">
          <Button to="/equipment">View Equipment</Button>
        </div>
      </div>
    </section>
  );
}

export default EquipmentPreview;
